import React from "react";
import SEO, { buildLocalBusinessJsonLd } from "@/components/SEO";
import { PageHeader, Section } from "@/components/Primitives";
import QuoteForm from "@/components/QuoteForm";
import { BUSINESS } from "@/data/config";
import { Phone, Mail, Clock, MapPin } from "lucide-react";

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact Spokane Gutter Co. | Free On Site Quote"
        description={`Request a free gutter or roofing quote in Spokane. Call ${BUSINESS.phone} or send the form and we will reply within one business day.`}
        path="/contact"
        jsonLd={buildLocalBusinessJsonLd()}
      />
      <PageHeader
        overline="Contact"
        title="Get a free on site quote. No hard sell."
        lede="Send the form or call us direct. We reply within one business day. On site quotes are free and there is never a fee to compare to another bid."
      />

      <Section testid="contact-body" className="!pt-0">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5 space-y-8">
            <InfoRow
              icon={<Phone className="w-5 h-5" />}
              label="Call the shop"
              value={BUSINESS.phone}
              href={BUSINESS.phoneHref}
              testid="contact-phone"
            />
            <InfoRow
              icon={<Mail className="w-5 h-5" />}
              label="Email"
              value={BUSINESS.email}
              href={BUSINESS.emailHref}
              testid="contact-email"
            />
            <InfoRow
              icon={<MapPin className="w-5 h-5" />}
              label="Service area"
              value="Spokane, Spokane Valley, Liberty Lake, Mead, Cheney, Nine Mile Falls"
              testid="contact-area"
            />
            <div className="border-t border-white/10 pt-8">
              <div className="flex items-center gap-3 mb-4">
                <Clock className="w-5 h-5 text-copper-500" />
                <span className="overline">Hours</span>
              </div>
              <ul className="space-y-2 text-bone-200 font-heading text-sm">
                {BUSINESS.hours.map((h) => (
                  <li key={h.day} className="flex justify-between border-b border-white/5 pb-2">
                    <span>{h.day}</span>
                    <span className="text-bone-400">
                      {h.open === "Closed" ? "Closed" : `${h.open} – ${h.close}`}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="lg:col-span-7">
            <QuoteForm />
          </div>
        </div>
      </Section>
    </>
  );
}

function InfoRow({ icon, label, value, href, testid }) {
  const Wrap = href ? "a" : "div";
  return (
    <Wrap
      href={href}
      data-testid={testid}
      className="flex items-start gap-4 group"
    >
      <span className="mt-1 w-10 h-10 rounded-sm border border-white/10 flex items-center justify-center text-copper-500 group-hover:border-copper-500 transition-colors">
        {icon}
      </span>
      <div>
        <div className="overline mb-1">{label}</div>
        <div className="text-lg md:text-xl font-heading text-bone-50 group-hover:text-copper-500 transition-colors">
          {value}
        </div>
      </div>
    </Wrap>
  );
}
